var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0013 12.9404C20.1254 12.164 20.9134 10.8892 20.9134 9.70719C20.9134 7.08818 18.8854 5.07178 16.278 5.07178H9.03516V21.2957H17.1935C19.6155 21.2957 21.4928 19.3257 21.4928 16.9037C21.4928 15.1422 20.4962 13.6357 19.0013 12.9404ZM12.5117 7.96891H15.9883C16.9501 7.96891 17.7266 8.74534 17.7266 9.70719C17.7266 10.669 16.9501 11.4455 15.9883 11.4455H12.5117V7.96891ZM16.5677 18.3986H12.5117V14.922H16.5677C17.5296 14.922 18.306 15.6985 18.306 16.6603C18.306 17.6222 17.5296 18.3986 16.5677 18.3986Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.921875 0.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.bad850481267a5c44641ee2b77776682.svg";
export { ForwardRef as ReactComponent };